"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseOptionViewModel = void 0;
var ResponseOptionViewModel = /** @class */ (function () {
    function ResponseOptionViewModel(responseOption, defaultCultureCode) {
        var _a;
        this.responseOptionId = responseOption.responseOptionId;
        this.displayOrder = responseOption.displayOrder;
        var defaultTranslation = (_a = responseOption.translations) === null || _a === void 0 ? void 0 : _a.find(function (t) { return t.cultureCode === defaultCultureCode; });
        this.displayText = defaultTranslation ? defaultTranslation.text : responseOption.name;
    }
    return ResponseOptionViewModel;
}());
exports.ResponseOptionViewModel = ResponseOptionViewModel;
